import BaseExtension from './base';

import createElement from '../utils/createElement';

import addClass from '../utils/addClass';
import removeClass from '../utils/removeClass';

import createSvg, { SPINNER } from '../svgs';

const CN = 'rmp-ext-buffering';
const PROCESSING_CN = `${CN}--processing`;

export default class BufferingExtension extends BaseExtension {
   _timerId

   constructor(player, state, options) {
      super(player, state, options, ['seeking', 'waiting', 'seeked', 'canplay', 'playing', 'timeupdate']);
      this.logger.debug('buffering:extension:creating');

      this.render();
      if (!options.isMobile) {
         this.startProcessing();
      }
      this.logger.debug('buffering:extension:created');
   }

   onWaiting() {
      this.startProcessing();
   }

   onSeeking() {
      this.startProcessing();
   }

   startProcessing() {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => addClass(this.$outer, PROCESSING_CN), this.options.bufferingTimeout);
   }

   onTimeupdate() {
      this.hideProcessing();
   }

   onSeeked() {
      this.hideProcessing();
   }

   onCanplay() {
      this.hideProcessing();
   }

   onPlaying() {
      this.hideProcessing();
   }

   render() {
      /** @type {HTMLMediaElement} */
      this.$outer = createElement('div', { class: CN });
      const span = createElement('span', { class: `${CN}__message` }, this.$outer);
      createSvg(span, SPINNER, {});
   }

   getOuter() {
      return this.$outer;
   }

   hideProcessing() {
      clearTimeout(this._timerId);
      removeClass(this.$outer, PROCESSING_CN);
   }

   destroy() {
      super.destroy();
      const parent = this.$outer.parentNode;
      parent.removeChild(this.$outer);
      this.$outer = null;
   }
}
